import { AI_MODEL } from '@/settings/subscription-settings/ai-settings/ai-settings.const.js';

// Passthrough so segment-flag-guards.json can enforce earliestRemovalAt on beta flags.
export const betaSegmentFlag = (flag) => flag;

export const ROLLOUT_MODE = {
    self: 'self',
    specific: 'specific',
    everyone: 'everyone',
};

export const DEFAULT_ROLLOUT_MODES = [ROLLOUT_MODE.self, ROLLOUT_MODE.specific, ROLLOUT_MODE.everyone];

// See https://pendo-io.atlassian.net/wiki/spaces/ENG/pages/5017829378/Beta+Enrollment+page for more information.
export const BETAS = [
    {
        id: 'spaces',
        nameKey: 'betasSettings.spacesName',
        descriptionKey: 'betasSettings.spacesDescription',
        routeName: 'SpacesList',
        tags: ['New'],
        aiModels: [AI_MODEL.google],
        rolloutModes: DEFAULT_ROLLOUT_MODES,
        // visibleToUsers is the kill switch for the beta, if the segment flag is false, the beta is not visible to any users
        visibleToUsers: betaSegmentFlag('spacesFlag'),
    },
    {
        id: 'vocSignals',
        nameKey: 'betasSettings.vocSignalsName',
        descriptionKey: 'betasSettings.vocSignalsDescription',
        routeName: 'ListenSignals',
        tags: ['New'],
        aiModels: [AI_MODEL.google],
        rolloutModes: DEFAULT_ROLLOUT_MODES,
        requires: [
            {
                type: 'productLine',
                value: 'voc',
                metadata: 'exploreSettings.enabled',
                tooltipKey: 'betasSettings.vocSignalsRequiresExploreTooltip',
            },
            {
                type: 'flag',
                value: 'doNotProcessPendoAi',
                mustBe: false,
                tagKey: 'betasSettings.aiDisabledTag',
                tooltipKey: 'betasSettings.aiDisabledTooltip',
            },
            {
                type: 'flag',
                value: 'pendoFree',
                mustBe: false,
                tooltipKey: 'betasSettings.vocSignalsRequiresPlanTooltip',
            },
            {
                type: 'flag',
                value: 'enableListenAISignals',
                disableWhenNoEnrollments: true,
            },
        ],
    },
    {
        id: 'leoModelProviderBetaOptIn',
        nameKey: 'betasSettings.leoModelProviderName',
        descriptionKey: 'betasSettings.leoModelProviderDescription',
        routeName: 'LeoHomepage',
        tags: ['New'],
        aiModels: [AI_MODEL.google],
        usAiModels: [AI_MODEL.openAi, AI_MODEL.anthropic],
        rolloutModes: DEFAULT_ROLLOUT_MODES,
        visibleToUsers: [betaSegmentFlag('leoDeepAgents'), betaSegmentFlag('leoModelProvider')],
    },
    {
        id: 'aiGuideCodeEditor',
        nameKey: 'betasSettings.aiGuideCodeEditorName',
        descriptionKey: 'betasSettings.aiGuideCodeEditorDescription',
        tags: ['New'],
        rolloutModes: [ROLLOUT_MODE.self, ROLLOUT_MODE.specific],
        requires: [
            {
                type: 'productLine',
                value: 'guides',
                tooltipKey: 'betasSettings.aiGuideCodeEditorRequiresProductLineTooltip',
            },
            {
                type: 'productLine',
                value: 'guides',
                metadata: 'customCodeBlocksEnabled',
                tooltipKey: 'betasSettings.aiGuideCodeEditorRequiresContentTooltip',
            },
            {
                type: 'flag',
                value: 'enableGenerateAIGuideContent',
                blocking: true,
                tooltipKey: 'betasSettings.aiGuideCodeEditorRequiresFlagTooltip',
            },
        ],
        resources: [
            { labelKey: 'betasSettings.aiGuideCodeEditorResourceVideoInstall', href: 'https://www.loom.com/share/3649abf6e962474b980a36af38606951' },
            { labelKey: 'betasSettings.aiGuideCodeEditorResourceVideoSkill', href: 'https://www.loom.com/share/1abc2fcdf7884bec95d6bfc19755e447' },
            { labelKey: 'betasSettings.aiGuideCodeEditorResourceVideoImport', href: 'https://www.loom.com/share/a9d42a30c58644a682ee8c82602a963c' },
            { labelKey: 'betasSettings.aiGuideCodeEditorResourceRepo', href: 'https://github.com/pendo-io/claude-pendo-plugin' },
            { labelKey: 'betasSettings.aiGuideCodeEditorResourceSlack', href: 'https://join.slack.com/t/pendo-connect/shared_invite/zt-43hva7nab-a3GOO4_wIA6U9BadGnqg8g' },
        ],
        visibleToUsers: betaSegmentFlag('aiGuideCodeEditor'),
    },
];
